import { useSuggestions } from '@hooks/useSuggestions';
import SvgSearch from '@img/icons/search.svg';
import * as React from 'react';
import { useFocusWithin } from 'react-aria';
import S from './MobileSearch.styles';
const MobileSearch = (props) => {
    const { data, searchTerm, setSearchTerm } = useSuggestions({
        initialValue: props.initialValue ?? '',
    });
    const [focus, setFocus] = React.useState(false);
    const { focusWithinProps } = useFocusWithin({
        onFocusWithinChange: (value) => setFocus(value),
    });
    const showSuggestions = focus && !!searchTerm && !!data?.items.length;
    return (React.createElement(S.Container, { action: props.searchUrl, ...focusWithinProps, "data-active": props.isActive },
        React.createElement(S.SiteWide, null,
            React.createElement(S.Inner, null,
                React.createElement(S.InputWrapper, null,
                    React.createElement(S.Input, { id: "searchTextMobile", autoComplete: "off", name: "searchText", placeholder: "What are you looking for?", type: "search", value: searchTerm, onChange: (event) => {
                            setSearchTerm(event.target.value);
                        } }),
                    React.createElement(S.Button, null,
                        React.createElement(S.ButtonIcon, { as: SvgSearch }),
                        React.createElement(S.ButtonLabel, null, "Search"))),
                showSuggestions && (React.createElement(S.SuggestionWrapper, null,
                    React.createElement(S.SuggestionList, null, data.items.map((item) => (React.createElement(S.Suggestion, { key: item.id },
                        React.createElement(S.SuggestionLink, { "aria-label": item.title, href: item.url },
                            React.createElement(S.SuggestionTitle, null, item.title),
                            React.createElement(S.SuggestionSubtitle, null, item.subtitle))))))))))));
};
export default MobileSearch;
